import { EventEmitter, Output, Directive, Input } from "@angular/core";

@Directive()
export class GenericTableAnagraphTable {
  @Output() changedSelected = new EventEmitter<any>();

  @Input("CurrentObject") CurrentObject: any = null;
  @Input("allowDetectionListChange") allowDetectionListChange: boolean = true;
  @Input("selectedObjectArray") selectedObjectArray: Array<any> = [];
  @Input("isDeselectedAllProperties") isDeselectedAllProperties: boolean =
    false;

  public OnChanges(): void {}
}
